import PropTypes from 'prop-types';
import { useForm, useWatch } from 'react-hook-form';
import FormRow from '@/components/core/form/FormRow';
import { useNodeHierarchy, useNodes } from '@/stores/analysisStore';
import { useEffect } from 'react';
import Select from '@/components/core/form/Select';
import { FormProvider } from 'react-hook-form';
import { getEmissionTypes } from '@/utils/pathwayUtils';
import { getBalanceNodeOptions, isInternalNodeSelection } from '@/utils/balanceUtils';
import { TIME_UNIT_OPTIONS } from '@/consts';
import debounce from 'debounce';

const BalanceForm = ({ defaultValues, onSubmit }) => {
  const methods = useForm({ defaultValues });
  const { handleSubmit, control, setValue, reset } = methods;
  const nodes = useNodes();
  const nodeHierarchy = useNodeHierarchy();

  const [nodeId] = useWatch({
    control,
    name: ['nodeId'],
    defaultValue: defaultValues,
  });

  const nodeOptions = getBalanceNodeOptions(nodeHierarchy);
  // internal pathway nodes have no LCA emissions, so there is nothing to select
  const isInternalNode = isInternalNodeSelection(nodeId);

  const emissionTypeOptions = getEmissionTypes(nodes);
  const defaultEmissionType = emissionTypeOptions?.[0]?.value;

  const debouncedSubmit = debounce(() => handleSubmit(onSubmit)(), 10);

  // when node is changed update default emissionType
  useEffect(() => {
    setValue('emissionType', defaultEmissionType);
  }, [nodeId, defaultEmissionType, setValue]);

  useEffect(() => {
    reset(defaultValues);
  }, [reset, defaultValues]);

  return (
    <FormProvider {...methods}>
      <div className="group node">
        <form onChange={debouncedSubmit}>
          <input type="hidden" {...methods.register('levelize', { value: 'false' })} />
          <div className="mt-2 grid grid-cols-6 gap-2">
            <FormRow label="Module" name="nodeId" className="col-span-1">
              <Select name="nodeId" className="w-full truncate" options={nodeOptions} />
            </FormRow>
            {!isInternalNode && (
              <FormRow label="Emissions Type" name="emissionType">
                <Select className="w-full truncate" name="emissionType" options={emissionTypeOptions} />
              </FormRow>
            )}
            <FormRow label="Time Unit" name="timeUnit">
              <Select className="w-full truncate" name="timeframe" options={TIME_UNIT_OPTIONS} />
            </FormRow>
          </div>
        </form>
      </div>
    </FormProvider>
  );
};

BalanceForm.propTypes = {
  params: PropTypes.arrayOf(PropTypes.object),
  defaultValues: PropTypes.object,
  onSubmit: PropTypes.func,
};

export default BalanceForm;
